import Link from 'next/link'
import React from 'react'
import styled from 'styled-components'

import { useTracking } from '../../hooks'
import { resizeImg } from '../../utils/commonUtils'
import { objectFit } from '../../utils/cssUtils'
import { detailClickHero } from '../../utils/dataTracker'

const StyledCatIcons = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-flow: row wrap;
  margin-top: 16px;
`
const CatIcon = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  height: 24px;
  background-color: #f5f5f5;
  margin: 8px 8px 0 0;
  padding: 4px 8px;
  border-radius: 4px;
`
const CatIconImg = styled.img`
  min-width: 30px;
  height: 100%;
  object-fit: contain;
  ${objectFit('contain')}
  display: inline-block;
  margin-right: 5px;
  &:last-child {
    margin-right: 0;
  }
`

const CatIcons = ({ projectPromoCategory, projectNo, projectName }) => {
  const track = useTracking()

  const handleClick = categoryNo => e => {
    track(detailClickHero('category', categoryNo, projectNo, projectName))
  }

  return (
    <StyledCatIcons>
      {projectPromoCategory.map(
        ({ miniIconImage, categoryNo, displayName }, i) => (
          <Link href={`/discover?categories=${categoryNo}`} key={categoryNo}>
            <a onClick={handleClick(categoryNo)}>
              <CatIcon>
                <CatIconImg
                  src={resizeImg(miniIconImage, 96)}
                  title={displayName}
                />
                <span>{displayName}</span>
              </CatIcon>
            </a>
          </Link>
        )
      )}
    </StyledCatIcons>
  )
}

export default React.memo(CatIcons)
